<template>
  <el-card shadow="always" title="专业简历辅导" style="margin-top:14px;">
    <div slot="header" class="clearfix">
      <span style="width: 100%;
    display: inline-block;
    text-align: left;
    margin-bottom: 16px;">专业简历辅导</span>
    </div>
    <router-link to="ProfessionalResume?id=1">
      <img style="width: 298px;"
        src="//static.letiao.com/upload/MallProductDetailImage/2019/f931254d95f94847ad0ada2d1fda7596.jpg" />
    </router-link>
  </el-card>
</template>

<script>
  export default {

  };
</script>

<style>

</style>